function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import cn from 'classnames';
import { CloseButton, GridItem, TextButton, TextField, useOverlayContext, WithInfoIcon } from 'seagull';
import IntroVideoModal from "./IntroVideoModal/IntroVideoModal";
import { isUrlValid } from "./IntroVideoModal/IntroVIdeoModal.utils";
import VideoPlayer from "../../../VideoPlayer/VideoPlayer";
import { introVideoModel } from "../../../../models";
import { makeIntroVideoLink, makeIntroVideoNone } from "../../../../models/intro-video";
import styles from "./IntroVideoField.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IntroVideoField = _ref => {
  let {
    introVideo,
    onChange,
    className,
    disabled
  } = _ref;
  const overlayContext = useOverlayContext();
  const [videoName, setVideoName] = useState('');
  const videoLink = introVideoModel.videoUrl(introVideo) || '';
  const onIntroVideoSave = (videoName, videoLink) => {
    setVideoName(videoName);
    onChange(makeIntroVideoLink(videoLink.trim()));
  };
  const openIntroVideoModal = async () => {
    await overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: p => /*#__PURE__*/_jsx(IntroVideoModal, _objectSpread({
        onSave: onIntroVideoSave,
        videoLink: videoLink
      }, p))
    });
  };
  return /*#__PURE__*/_jsxs(GridItem, {
    span: 12,
    className: cn(styles.firstRow, className),
    children: [/*#__PURE__*/_jsxs(WithInfoIcon, {
      info: "This video will show as an introductory video on the proposal your client receives",
      children: [!videoName && /*#__PURE__*/_jsx(TextButton, {
        "data-testid": "add-intro-video",
        disabled: disabled,
        underline: "none",
        onClick: openIntroVideoModal,
        children: "+ Add an introductory video"
      }), isUrlValid(videoLink) && !videoName && /*#__PURE__*/_jsx("div", {
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsx(VideoPlayer, {
          url: videoLink,
          onReady: _ref2 => {
            let {
              videoName
            } = _ref2;
            setVideoName(videoName);
          }
        })
      }), videoName && /*#__PURE__*/_jsx(TextField, {
        collapseHelperText: false,
        width: 512,
        label: "Introductory video",
        "data-testid": "intro-video-name",
        value: videoName,
        disabled: disabled,
        disableSuffixPadding: true,
        suffix: !disabled && /*#__PURE__*/_jsx(CloseButton, {
          "data-testid": "intro-video-remove-video-name-button",
          skin: "transparent",
          onClick: () => {
            setVideoName('');
            onChange(makeIntroVideoNone());
          }
        })
      })]
    }), /*#__PURE__*/_jsx(TextButton, {
      "data-testid": "intro-video-preview",
      onClick: openIntroVideoModal,
      disabled: disabled,
      style: {
        visibility: videoName ? 'visible' : 'hidden'
      },
      children: "Preview"
    })]
  });
};
export default IntroVideoField;